import { MonoTypeOperatorFunction, map } from 'rxjs';
import { toNestedCamelCaseKeys } from './stringUtils';

/**
 * RxJS custom operator to convert all keys of an object/array of objects to camel case.
 */
export const camelizeKeys = <T>(): MonoTypeOperatorFunction<T> => {
  return (source) => source.pipe(map((data) => toNestedCamelCaseKeys(data)));
};
